import { ClassSubjectTeachersType } from "../../../types/Teacher";
import { post } from "../../../utils/axios-config";
import { TEACHERS_CLASSES_SUBJECTS } from "../../../utils/constants";

export const assignTeacherToSubject = async (data: ClassSubjectTeachersType) => await post<ClassSubjectTeachersType, boolean>(TEACHERS_CLASSES_SUBJECTS, data);